import { LocationDetailsWizardAnswers, LocationDetailsWizardStep, buildingTypesWithAccess } from "src/app/shared/location-details-wizard/location-details-wizard.state";

export const getNextStep = (currentStep: LocationDetailsWizardStep, answers: Partial<LocationDetailsWizardAnswers>) => {
  const steps = getSteps(answers);
  return steps[steps.indexOf(currentStep) + 1];
}

export const getPreviousStep = (currentStep: LocationDetailsWizardStep, answers: Partial<LocationDetailsWizardAnswers>) => {
  const steps = getSteps(answers);
  return steps[steps.indexOf(currentStep) - 1];
}

export const ordinalSuffix = (n: number): string => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
};

export const getSteps = ({ buildingType, access }: Partial<LocationDetailsWizardAnswers>): LocationDetailsWizardStep[] => {

  if (!(buildingTypesWithAccess.includes(buildingType))) {
    return [ 'buildingType', 'size' ];
  }

  if (buildingType === 'Storage Unit' && access === 'elevator') {
    return [ 'buildingType', 'size', 'access', 'floor'];
  }

  switch (access) {
    case 'elevator':
      return [ 'buildingType', 'size', 'access', 'elevatorType', 'floor' ];
    case 'stairs':
      return [ 'buildingType', 'size', 'access', 'floor' ];
    case 'none':
    case 'outdoors':
    default:
      return [ 'buildingType', 'size', 'access' ];
  }
}
